<div class="download-panel">
  <div class="qr-wrapper">
    <qrcode
      [qrdata]="qrUrl"
      [width]="200"
      [errorCorrectionLevel]="'M'"
    ></qrcode>
  </div>

  <div class="store-badges">
    <a
      class="store-badge-link"
      [href]="appStoreUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="assets/image/download-on-app-store.svg"
        width="160"
        height="54"
        alt="Download on the App Store"
      />
    </a>
    <a
      class="store-badge-link"
      [href]="playStoreUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="assets/image/google-play-badge.png"
        width="180"
        height="54"
        alt="Get it on Google Play"
      />
    </a>
  </div>
</div>
